import { render, staticRenderFns } from "./bloggerOrgin.vue?vue&type=template&id=74580756&scoped=true&"
import script from "./bloggerOrgin.vue?vue&type=script&lang=js&"
export * from "./bloggerOrgin.vue?vue&type=script&lang=js&"
import style0 from "./bloggerOrgin.vue?vue&type=style&index=0&id=74580756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74580756",
  null
  
)

export default component.exports